const UPLOADS_V1_URL_PREFIX = 'https://uploads.documents.cimpress.io/v1/uploads/';
const SHERBERT_V1_URL_PREFIX = 'https://sherbert-api.storage.cimpress.io/v1/assets/';
const SHERBERT_V2_URL_PREFIX = 'https://api.sherbert.cimpress.io/v2/assets/';
// This tenant is guaranteed to be present as a query param
// in URLs to resources created by Sherbert V1 in Uploads V1.
// https://cimpress.slack.com/archives/CUT57FQ3W/p1658476201878619
const UPLOADS_SHERBERT_TENANT = 'sherbert-uploads';
function hasLegacySherbertTenant(stringUrl) {
    try {
        const url = new URL(stringUrl);
        const tenantParam = url.searchParams.get('tenant');
        return tenantParam === UPLOADS_SHERBERT_TENANT;
    }
    catch (_a) {
        return false;
    }
}
/**
 * Checks if the given string is a URL from Sherbert V2.
 */
export function isSherbertAssetUrl(url) {
    return !!url && url.startsWith(SHERBERT_V2_URL_PREFIX);
}
/**
 * Checks if the given string is a URL from Sherbert V1.
 *
 * This includes direct URLs to Sherbert assets, as well as URLs to resources created by Sherbert in Uploads V1.
 */
export function isLegacySherbertAssetUrl(url) {
    return (!!url &&
        (url.startsWith(SHERBERT_V1_URL_PREFIX) ||
            (url.startsWith(UPLOADS_V1_URL_PREFIX) && hasLegacySherbertTenant(url))));
}
/**
 * Checks if the given string is a URL from Uploads V1.
 *
 * This doesn't include URLs to resources created by Sherbert.
 */
export function isUploadsAssetUrl(url) {
    return !!url && url.startsWith(UPLOADS_V1_URL_PREFIX) && !hasLegacySherbertTenant(url);
}
//# sourceMappingURL=isAssetUrl.js.map